import type { BadgeTone } from '@artosera/ui';

/** Sous ce nombre de jours, une échéance à venir passe à l'ambre (3.3, écran 4). */
const SEUIL_PROCHE_JOURS = 30;

/**
 * Jours civils restants avant une échéance (même règle que le serveur,
 * `apps/api/src/coffre/echeances.ts` § 18.7) : un 1er mars à 9 h vu le 28
 * février à 23 h est à UN jour, jamais à zéro.
 */
export function joursRestantsEcheance(echeanceLe: string, maintenant = new Date()): number {
  const echeance = new Date(echeanceLe);
  const jourEcheance = Date.UTC(echeance.getFullYear(), echeance.getMonth(), echeance.getDate());
  const jourCourant = Date.UTC(
    maintenant.getFullYear(),
    maintenant.getMonth(),
    maintenant.getDate(),
  );
  return Math.round((jourEcheance - jourCourant) / (24 * 60 * 60 * 1000));
}

export type UrgenceEcheance = 'aucune' | 'proche' | 'depassee';

/** Rouge dépassée, ambre sous 30 jours, neutre au-delà (cahier des charges S5-d). */
export function urgenceEcheance(joursRestants: number): UrgenceEcheance {
  if (joursRestants < 0) return 'depassee';
  if (joursRestants <= SEUIL_PROCHE_JOURS) return 'proche';
  return 'aucune';
}

const TEINTE_PAR_URGENCE: Record<UrgenceEcheance, BadgeTone> = {
  aucune: 'neutral',
  proche: 'reserved',
  depassee: 'sold',
};

export function teinteDeLEcheance(joursRestants: number): BadgeTone {
  return TEINTE_PAR_URGENCE[urgenceEcheance(joursRestants)];
}
